/**
 * 请求封装
 */
 import axios from 'axios';
 import configUrl from './url.js';
//  import store from '../store';
 import cookies from "vue-cookies";
 import router from "../router/index"
 
 const service = axios.create({
     baseURL: configUrl.baseURL,
     // withCredentials: true, // 当跨域请求时发送cookie
     timeout: 50000 // 请求超时
 });
 
 //添加请求拦截器   请求接口统一添加token
 service.interceptors.request.use(
     config =>{
        config.headers['PC-LOGIN-SESSION-ID'] = cookies.get('supplier_token')||''
        //  config.headers.PC-LOGIN-SESSION-ID = cookies.get('gys_token');  //请求添加token
         return config;
     },
     error =>{
         return Promise.reject(error);
     }
 )
 
 // 响应拦截器
 service.interceptors.response.use(
     response => {
         //如果接口返回token，替换本地旧token
         if (response.headers.token) {
             sessionStorage.setItem("token", response.headers.token);
         }
        //  console.log('拦截器响应',response)
            //自定义设置后台返回code对应的响应方式
            if (response.data.code == 0) { // 请求成功
                return response.data;
            } else if(response.data.code == 100){ //token过期
                router.app.$api.e_msg(response.data.msg)
                setTimeout(() => {
                    router.app.$router.push({ path: '/' })
                }, 900)
                
                
                return response.data;
           // router.app.$router.replace('/login')
           //  return Promise.reject(new Error('登录超时'));
           // console.log(router)
            }else{
                return response.data;
            }
            // return response.data;
         


         
     },
     error => {
         if (error.message) {
                 // this.$massage.error('服务器开小差了，请稍后再试!')   
                 //错误响应
                //  alert('服务器开小差了，请稍后再试!')   
         }
         return Promise.reject(error);
     }
 );
 //暴露出封装过的服务
 export default service;